import { createLazyFileRoute } from "@tanstack/react-router";

import { ProcessDetailForm } from "@/features/admin/components/processes/ProcessDetailForm";
import { Section } from "@/features/admin/components/Section";

export const Route = createLazyFileRoute("/_auth/admin/processes/new")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex flex-col flex-1">
      <Section.Title>New process</Section.Title>
      <ProcessDetailForm />
    </div>
  );
}
